import React from 'react';

import { Scale } from '~src/interfaces/scale.interface';
import { Topic } from '~src/interfaces/topic.interface';
import { translateContent } from '~src/services/translationServices';
import ListItem from '~src/shared/lists/listItem/ListItem';
import { HoverContent, ListItemProps } from '~src/shared/lists/listItem/types';
import {useTranslation} from "react-i18next";

interface Props {
  scale: Scale;
  topic: Topic;
  link: string;
  locationState: Record<string, unknown>;
}

const MemoizedTopicItem: React.FC<Props> = React.memo(function TopicItem({ topic, scale, link, locationState }) {
  const [t] = useTranslation();
  const itemProps: ListItemProps<string> = [
    {
      key: `x.topics.list.details.item.${topic.subject}`,
      txt: t(`x.topics.list.details.item.${topic.subject}`),
    },
    {
      key: 'x.topics.list.details.item.questions.amount',
      txt: t('x.topics.list.details.item.questions.amount', { count: topic.questionCount }),
    },
    {
      key: `x.topics.list.details.item.visualization.${scale ? scale.visualization : 'stars'}`,
      txt: t(`x.topics.list.details.item.visualization.${scale ? scale.visualization : 'stars'}`, { name: translateContent(scale.name)}),
    },
  ];

  const hoverContent: HoverContent = {
    wideBtn: {
      key: 'x.topics.list.details.item.edit_label',
      txt: t('x.topics.list.details.item.edit_label'),
      icon: 'iconGear',
      link,
      locationState,
    },
  };

  return <ListItem title={translateContent(topic.name)} itemProps={itemProps} hoverContent={hoverContent} />;
});

export default MemoizedTopicItem;
